import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

const useStyles = makeStyles((theme: typeof muiTheme) => ({
    flexColumn: {
        display: 'flex' as 'flex',
        flexFlow: 'column nowrap' as 'column nowrap',
        flexGrow: 1,
        alignItems: 'center' as 'center',
        marginTop: '1rem'
    },
    fieldContainer: {
        width: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2rem',
        marginBottom: '1rem'
    },
    sectionTitle: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontFamily: 'Corporate S',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.5rem',
        paddingBottom: '0.5rem'
    },
    assetEquivalency: {
        color: '#000',
        fontFamily: 'Corporate S',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.5rem',
        paddingBottom: '0.31rem'
    },
    balanceText: {
        color: 'var(--Background-Colors-Tassat-Black, #202020)',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        marginTop: '0.25rem'
    },
    submitContainer: {
        marginTop: '2rem',
        alignItems: 'center'
    },
    legalText: {
        fontSize: '11px',
        marginTop: '3rem',
        color: 'black',
        '& a, a:hover, a:visited': { fontWeight: 'bold' }
    }
}));

export default useStyles;